import { useEffect } from 'react';

import { useSetTeamsConfigActions } from '../../store/main';
import { type TeamsNavigationConfig } from '../../types';

export const useSetTeamsNavigationConfig = (config: TeamsNavigationConfig) => {
	const { setNavigationConfig } = useSetTeamsConfigActions();

	useEffect(() => {
		setNavigationConfig(config);
	}, [setNavigationConfig, config]);
};
